<template>
  <div v-if="loadingObjectData" class="content-container flex-column" @keyup.esc="close()" tabindex="0">
    <div class="content-container flex-row">
      <section class="content modal-main-content">
        <TheLoader :active="true"/>
      </section>
    </div>
  </div>
  <div v-else class="content-container flex-column">
    <div class="content-container flex-row">
      <!-- SHOW -->
      <section class="content modal-main-content" :class="{'hidden': edit}" id="preview-object">
        <TheLoader v-if="reloadingObjectData" :active="true" :update="true"/>

        <!-- Toolbar -->
        <div class="grid-x toolbar responsive-small-only" :style="{ 'background-color': avantiEnv === 'staging' ? 'rgb(160 183 206)' : '#fff' }">
          <div class="cell auto toolbar-responsive">
            <div class="tabs large" id="object-tabs">
              <ul>
                <li v-for="(tabItem, key) in tabs" :key="key" :class="{'active' : key === selectedTab, 'error': key === 'selger' && objekt.last_oppgjor_logg && objekt.last_oppgjor_logg.Failed}">
                  <a href="javascript:;" @click="tab(key)">{{ tabItem.name }}</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="cell shrink toolbar-responsive">
            <div class="avatar-group" :style="{
              'color': avantiEnv === 'staging' ? 'rgb(160 183 206)' : '#fff',
              'background-color': avantiEnv === 'staging' ? 'rgb(160 183 206)' : '#fff'
            }">
              <span class="avatar-group-title">Brukere:</span>
              <ul v-if="presenceLoading || reloadingObjectData">
                <li class="active">
                  <span class="avatar name center yellow">
                    <span class="initials">?</span>
                    <span class="name">
                      <span class="title">
                        Laster...
                      </span>
                    </span>
                  </span>
                </li>
              </ul>
              <ul v-else-if="presenceErrors">
                <li class="active">
                  <span class="avatar name center red">
                    <span class="initials">!</span>
                    <span class="name">
                      <span class="title">
                        Kunne ikke koble til websocket...
                      </span>
                    </span>
                  </span>
                </li>
              </ul>
              <ul v-else-if="presenceMe.id">
                <li class="active">
                  <span class="avatar name center" :class="strToAvatarClass(presenceMe.info.initials)">
                    <span class="initials">{{presenceMe.info.initials}}</span>
                    <span class="name">
                      <span class="title">{{presenceMe.info.fullname}} (deg)</span>
                      <span class="subtitle" v-if="presenceOwner.id === presenceMe.id">Redigerer</span>
                      <span class="subtitle" v-else>Ser på</span>
                    </span>
                    <span class="lock" v-if="presenceOwner.id === presenceMe.id">
                      <svg width="6px" height="7px" viewBox="0 0 6 7"><use xlink:href="/static/sprites.svg#glyph-lock-small"></use></svg>
                    </span>
                  </span>
                </li>
                <li v-for="user in visiblePresenceMembers" v-bind:key="user.id">
                  <span class="avatar name center" :class="strToAvatarClass(user.info.initials)">
                    <span class="initials">{{user.info.initials}}</span>
                    <span class="name">
                      <span class="title">{{user.info.fullname}}</span>
                      <span class="subtitle" v-if="presenceOwner.id === user.id">Redigerer</span>
                      <span class="subtitle" v-else>Ser på</span>
                    </span>
                    <span class="lock" v-if="presenceOwner.id === user.id">
                      <svg width="6px" height="7px" viewBox="0 0 6 7"><use xlink:href="/static/sprites.svg#glyph-lock-small"></use></svg>
                    </span>
                  </span>
                </li>
                <li class="more" v-if="invisiblePresenceMembers.length > 0">
                  <span class="avatar name center gray">
                    <span class="initials">+{{invisiblePresenceMembers.length}}</span>
                    <span class="name">
                      <span class="title" v-for="user in invisiblePresenceMembers" v-bind:key="'inv-' + user.id">
                        {{user.info.fullname}}
                      </span>
                    </span>
                  </span>
                </li>
              </ul>
            </div>

            <span class="button-container has-popover" :class="{'popover-active': actionsPopoverActive}" @click="toggleActionsPopover()">
              <a href="javascript:;" class="button action glyph glyph-only"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg></a>
              <span class="popover align-x-right align-y-bottom medium">
                <ul>
                  <li><a :href="'/kunde/' + kunde.Kundenr +'?kontrakt=' + kontrakt.Kontraktnr"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis kontrakt</span></a></li>
                  <li><a :href="baseUrl + '/object/preview/' + objekt.Objektnr" target="blank"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg> <span>Vis objekt på nett</span></a></li>
                  <li><a href="javascript:;" @click="action('print-etikett')"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg> <span>Skriv ut etiketter</span></a></li>
                  <li v-if="isPresenceOwner"><a href="javascript:;" @click="action('copy-objekt')"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg> <span>Kopier objekt</span></a></li>
                  <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg> <span>Kopier objekt</span></a></li>

                  <template v-if="this.hasAccess('accounting')">
                    <li v-if="isResetable"><a href="javascript:;" @click="resetConfirm()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg> <span>Nullstill objekt</span></a></li>
                    <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg> <span>Nullstill objekt</span></a></li>
                  </template>

                  <li v-if="isDeletable"><a href="javascript:;" @click="deleteConfirm()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett objekt</span></a></li>
                  <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett objekt</span></a></li>
                </ul>
              </span>
            </span>

            <!-- Print label btn -->
            <a href="javascript:;" class="button action glyph glyph-only" @click="action('print-etikett')">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg> <span>Skriv ut etiketter</span>
            </a>

            <ul class="button-group">
              <li>
                <a href="javascript:;" @click="toggleSidebar('objekter')" class="button action glyph glyph-only-small data-modal-sidepanel" :class="{'active': sidebarModal !== 'notater' && sidebarModal !== 'historikk'}">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
                  <span>Objekter</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" @click="toggleSidebar('notater')" class="button action glyph glyph-only-small data-modal-sidepanel" :class="{'active': sidebarModal === 'notater'}">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-comment"></use></svg>
                  <span v-if="notatCount">Objektnotater <span class="notifications-count">{{notatCount}}</span></span>
                  <span v-else>Objektnotater</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" @click="toggleSidebar('historikk')" class="button action glyph glyph-only-small data-modal-sidepanel" :class="{'active': sidebarModal === 'historikk'}">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-history"></use></svg>
                  <span>Historikk</span>
                </a>
              </li>
            </ul>

            <a v-if="isPresenceOwner" href="javascript:;" @click="toggleEdit()" class="button action glyph-only-small glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg> <span>Rediger</span></a>
            <a v-else href="javascript:;" class="button action glyph-only-small glyph disabled"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg> <span>Rediger</span></a>
          </div>
        </div>
        <!-- End Toolbar -->

        <div class="tab-content-wrapper">
          <component v-bind:is="selectedTabComponent" v-bind="{objekt: objekt, kunde: kunde}"></component>
        </div>
      </section>

      <!-- EDIT -->
      <section v-if="edit" class="content modal-main-content background" :class="{'hidden': !edit}" id="edit-object">
        <TheLoader v-if="reloadingObjectData" :active="true" :update="true"/>

        <div class="grid-x toolbar fixed" :style="{ 'background-color': avantiEnv === 'staging' ? 'rgb(160 183 206)' : '#fff' }">
          <div class="cell auto">
            <h4 class="no-margin toolbar-title">
              Rediger objekt {{objekt.Objektnr}} <span v-if="objekt.Tekst_ok !== 'T'"> (Kladd)</span>
              <br>
              <span class="opacity-60" style="font-size: 0.75rem;">
                Tittel: {{objekt.title | truncate(40)}}<span v-if="objekt.subtitle"> / {{objekt.subtitle | truncate(30)}}</span>
                |
                Selger: {{objekt.innlevav.full_name}}
                <template v-if="objekt.kontrakt.Kontraktinfo">
                  | {{objekt.kontrakt.Kontraktinfo}}
                </template>
              </span>
            </h4>
          </div>

          <div class="cell shrink">
            <div class="avatar-group" :style="{
              'color': avantiEnv === 'staging' ? 'rgb(160 183 206)' : '#fff',
              'background-color': avantiEnv === 'staging' ? 'rgb(160 183 206)' : '#fff'
            }">
              <span class="avatar-group-title">Brukere:</span>
              <ul v-if="presenceLoading || reloadingObjectData">
                <li class="active">
                  <span class="avatar name center yellow">
                    <span class="initials">?</span>
                    <span class="name">
                      <span class="title">
                        Laster...
                      </span>
                    </span>
                  </span>
                </li>
              </ul>
              <ul v-else-if="presenceErrors">
                <li class="active">
                  <span class="avatar name center red">
                    <span class="initials">!</span>
                    <span class="name">
                      <span class="title">
                        Kunne ikke koble til websocket...
                      </span>
                    </span>
                  </span>
                </li>
              </ul>
              <ul v-else-if="presenceMe.id">
                <li class="active">
                  <span class="avatar name center" :class="strToAvatarClass(presenceMe.info.initials)">
                    <span class="initials">{{presenceMe.info.initials}}</span>
                    <span class="name">
                      <span class="title">{{presenceMe.info.fullname}} (deg)</span>
                      <span class="subtitle" v-if="presenceOwner.id === presenceMe.id">Redigerer</span>
                      <span class="subtitle" v-else>Ser på</span>
                    </span>
                    <span class="lock" v-if="presenceOwner.id === presenceMe.id">
                      <svg width="6px" height="7px" viewBox="0 0 6 7"><use xlink:href="/static/sprites.svg#glyph-lock-small"></use></svg>
                    </span>
                  </span>
                </li>
                <li v-for="user in visiblePresenceMembers" v-bind:key="user.id">
                  <span class="avatar name center" :class="strToAvatarClass(user.info.initials)">
                    <span class="initials">{{user.info.initials}}</span>
                    <span class="name">
                      <span class="title">{{user.info.fullname}}</span>
                      <span class="subtitle" v-if="presenceOwner.id === user.id">Redigerer</span>
                      <span class="subtitle" v-else>Ser på</span>
                    </span>
                    <span class="lock" v-if="presenceOwner.id === user.id">
                      <svg width="6px" height="7px" viewBox="0 0 6 7"><use xlink:href="/static/sprites.svg#glyph-lock-small"></use></svg>
                    </span>
                  </span>
                </li>
                <li class="more" v-if="invisiblePresenceMembers.length > 0">
                  <span class="avatar name center gray">
                    <span class="initials">+{{invisiblePresenceMembers.length}}</span>
                    <span class="name">
                      <span class="title" v-for="user in invisiblePresenceMembers" v-bind:key="'inv-' + user.id">
                        {{user.info.fullname}}
                      </span>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
            <span class="button-container has-popover" :class="{'popover-active': actionsPopoverActive}" @click="toggleActionsPopover()">
              <a href="javascript:;" class="button action glyph glyph-only"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg></a>
              <span class="popover align-x-right align-y-bottom medium">
                <ul>
                  <li><a :href="'/kunde/' + kunde.Kundenr +'?kontrakt=' + kontrakt.Kontraktnr"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis kontrakt</span></a></li>
                  <li><a :href="baseUrl + '/object/preview/' + objekt.Objektnr" target="blank"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg> <span>Vis objekt på nett</span></a></li>
                  <li><a href="javascript:;" @click="action('print-etikett')"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg> <span>Skriv ut etiketter</span></a></li>
                  <li v-if="isPresenceOwner"><a href="javascript:;" @click="action('copy-objekt')"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg> <span>Kopier objekt</span></a></li>
                  <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg> <span>Kopier objekt</span></a></li>

                  <template v-if="this.hasAccess('accounting')">
                    <li v-if="isResetable"><a href="javascript:;" @click="resetConfirm()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg> <span>Nullstill objekt</span></a></li>
                    <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg> <span>Nullstill objekt</span></a></li>
                  </template>

                  <li v-if="isDeletable"><a href="javascript:;" @click="deleteConfirm()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett objekt</span></a></li>
                  <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett objekt</span></a></li>
                </ul>
              </span>
            </span>

            <!-- Print label btn -->
            <a href="javascript:;" class="button action glyph glyph-only" @click="action('print-etikett')">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg> <span>Skriv ut etiketter</span>
            </a>

            <ul class="button-group">
              <li>
                <a href="javascript:;" @click="toggleSidebar('objekter')" class="button action glyph glyph-only-small data-modal-sidepanel" :class="{'active': sidebarModal !== 'notater' && sidebarModal !== 'historikk'}">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
                  <span>Objekter</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" @click="toggleSidebar('notater')" data-modal-trigger="object-notes" class="button action glyph glyph-only-small data-modal-sidepanel" :class="{'active': sidebarModal === 'notater'}">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-comment"></use></svg>
                  <span v-if="notatCount">Objektnotater <span class="notifications-count">{{notatCount}}</span></span>
                  <span v-else>Objektnotater</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" @click="toggleSidebar('historikk')" data-modal-trigger="object-history" class="button action glyph glyph-only-small data-modal-sidepanel" :class="{'active': sidebarModal === 'historikk'}">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-history"></use></svg>
                  <span>Historikk</span>
                </a>
              </li>
            </ul>

            <div class="v-divider"></div>

            <span v-if="$store.getters.isFormSubmittable">
              <a href="javascript:;" @click="toggleEdit()" class="button primary transparent">Lukk</a>

              <template v-if="objekt.Tekst_ok === 'T'">
                <span class="button primary split" :class="{'disabled': !isPresenceOwner}">
                  <a v-if="isPresenceOwner" href="javascript:;" class="button-title initiate-loading" @click="onSaveButtonclick()" v-shortkey="['meta', 's']" @shortkey="theSaveShortkeyAction()">Lagre</a>
                  <a v-else href="javascript:;" class="button-title initiate-loading disabled">Lagre</a>

                  <span class="loader-spinner"></span>
                  <span class="split-button-arrow has-popover" :class="{'popover-active': savePopoverActive}" @click="toggleSavePopover()">
                    <svg width="6px" height="12px" viewBox="0 0 6 12"><use xlink:href="/static/sprites.svg#glyph-input-select-medium"></use></svg>
                    <span class="popover align-x-right align-y-bottom small">
                      <ul v-if="isPresenceOwner">
                        <li><a href="javascript:;" @click="onSaveButtonclick()"><span>Lagre</span></a></li>
                        <li><a href="javascript:;" @click="onSaveButtonclick(false)"><span>Lagre og sett som kladd</span></a></li>
                      </ul>
                      <ul v-else>
                        <li class="disabled"><a href="javascript:;"><span>Lagre</span></a></li>
                        <li class="disabled"><a href="javascript:;"><span>Lagre og sett som kladd</span></a></li>
                      </ul>
                    </span>
                  </span>
                </span>
              </template>
              <template v-else>
                <span class="button primary split" :class="{'disabled': !isPresenceOwner}">
                  <a v-if="isPresenceOwner" href="javascript:;" class="button-title initiate-loading" @click="onSaveButtonclick(false)" v-shortkey="['meta', 's']" @shortkey="theSaveShortkeyAction(false)">Lagre</a>
                  <a v-else href="javascript:;" class="button-title initiate-loading">Lagre</a>

                  <span class="loader-spinner"></span>
                  <span class="split-button-arrow has-popover" :class="{'popover-active': savePopoverActive}" @click="toggleSavePopover()">
                    <svg width="6px" height="12px" viewBox="0 0 6 12"><use xlink:href="/static/sprites.svg#glyph-input-select-medium"></use></svg>
                    <span class="popover align-x-right align-y-bottom small">
                      <ul v-if="isPresenceOwner">
                        <li><a href="javascript:;" @click="onSaveButtonclick(false)"><span>Lagre</span></a></li>
                        <li><a href="javascript:;" @click="onSaveButtonclick(true)"><span>Lagre og godkjenn</span></a></li>
                      </ul>
                      <ul v-else>
                        <li class="disabled"><a href="javascript:;"><span>Lagre</span></a></li>
                        <li class="disabled"><a href="javascript:;"><span>Lagre og godkjenn</span></a></li>
                      </ul>
                    </span>
                  </span>
                </span>
              </template>
            </span>
            <span v-if="$store.getters.isFormProcessing">
              <a href="javascript:;" class="button primary transparent">Lukk</a>
              <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
            </span>
            <span v-if="$store.getters.isFormLoading">
              <a href="javascript:;" @click="toggleEdit()" class="button primary transparent">Lukk</a>
              <a href="javascript:;" class="button primary" disabled>Lagre</a>
            </span>
          </div>
        </div>

        <KundeKontraktObjektForm :kunde="kunde" :kontrakt="kontrakt" :objekt="objekt"/>
      </section>

      <KundeKontraktObjektSidebar :kunde="kunde" :kontrakt="kontrakt" :objekt="objekt" :active="sidebarModal === 'objekter'" :hideme="sidebarModal === 'notater' || sidebarModal === 'historikk'"/>
    </div>

    <span v-if="$route.name !== 'KundeKontraktObjektFullscreen'">
      <a :href="itemFullscreenLink" target="_blank" class="modal-new-window-button"><span>Nytt vindu</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-new-window"></use></svg></a>
      <a href="javascript:;" @click="goToKontrakt()" class="modal-close modal-window-close-button"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
    </span>

    <div class="modal-window sidepanel right scrollable fullscreen-addon" :class="{'active': sidebarModal === 'notater'}">
      <KundeKontraktObjektSidebarNotater :kunde="kunde" :kontrakt="kontrakt" :objekt="objekt"/>
    </div>

    <div class="modal-window sidepanel right scrollable fullscreen-addon" :class="{'active': sidebarModal === 'historikk'}">
      <KundeKontraktObjektSidebarHistorikk :kunde="kunde" :kontrakt="kontrakt" :objekt="objekt"/>
    </div>

    <div class="modal-container" :class="{'active': deleteConfirmActive}">
      <div class="modal-window small" :class="{'active': deleteConfirmActive}">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3>Ønsker du å slette dette objektet?</h3>
            <br>
          </div>
        </div>
        <div class="modal-window-body gray">
          <p>
            <span class="opacity-80">Denne handlingen kan ikke angres.</span>
          </p>
        </div>
        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <button href="javascript:;" class="button primary transparent modal-close" @click="onDeleteConfirmFalse()">
                Avbryt
              </button>
              <button v-if="!isDeleting" href="javascript:;" class="button primary submit" @click="onDeleteConfirmTrue()">
                <span>Slett objekt</span>
              </button>
              <button v-else href="javascript:;" class="button primary submit loading">
                <span>Sletter... <span class="loader-spinner"></span></span>
              </button>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="deleteConfirmActive = false">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </div>
      <div v-if="deleteConfirmActive" class="modal-overlay" @click="deleteConfirmActive = false"></div>
    </div>

    <div class="modal-container" :class="{'active': resetConfirmActive}">
      <div class="modal-window small" :class="{'active': resetConfirmActive}">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3>Ønsker du å nullstille dette objektet?</h3>
            <br>
          </div>
        </div>
        <div class="modal-window-body gray">
          <p>
            <span class="opacity-80">Denne handlingen kan ikke angres.</span>
          </p>
        </div>
        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <button href="javascript:;" class="button primary transparent modal-close" @click="onResetConfirmFalse()">
                Avbryt
              </button>
              <button v-if="!isReseting" href="javascript:;" class="button primary submit" @click="onResetConfirmTrue()">
                <span>Nullstill objekt</span>
              </button>
              <button v-else href="javascript:;" class="button primary submit loading">
                <span>Nullstill objekt<span class="loader-spinner"></span></span>
              </button>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="resetConfirmActive = false">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </div>
      <div v-if="resetConfirmActive" class="modal-overlay" @click="resetConfirmActive = false"></div>
    </div>

    <div class="modal-container" :class="{'active': presenceInfoModalActive}" v-if="presenceOwner.id">
      <div class="modal-window small" :class="{'active': presenceInfoModalActive}">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3 class="icon-heading small">
              <template v-if="presenceInfoModalActive === 'warning'">
                <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-disabled"></use></svg></span>
                Objektet er låst for redigering
              </template>
              <template v-else-if="presenceInfoModalActive === 'reload'">
                <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-disabled"></use></svg></span>
                Objektet har blitt oppdatert
              </template>
            </h3>
          </div>
        </div>
        <div class="modal-window-body gray">
          <p v-if="presenceInfoModalActive === 'warning'">
            <br>
            <template v-if="presenceOwner.info.user_id === presenceMe.info.user_id">
              Dette objektet redigeres av <strong>deg</strong>, i en annen fane.
              Vennligst rediger objektet i den andre fanen.
            </template>
            <template v-else>
              Dette objektet redigeres av <strong>{{ presenceOwner.info.fullname }}.</strong>
              Du må vente til {{ presenceOwner.info.fullname }} har lukket objektet før du kan få skrivetilgang.
            </template>
          </p>
          <p v-else-if="presenceInfoModalActive === 'reload'">
            <br>
            Dette objektet har blitt oppdatert. Du må laste inn siden på nytt.
          </p>
        </div>
        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <button v-if="presenceInfoModalActive === 'warning'" href="javascript:;" class="button primary submit" @click="hidePresenceWarningModal()">
                Vis objekt
              </button>
              <button v-else-if="presenceInfoModalActive === 'reload'" href="javascript:;" class="button primary submit" @click="hidePresenceReloadModal()">
                Last inn på nytt
              </button>
            </div>
          </div>
        </div>

        <a v-if="presenceInfoModalActive === 'warning'" href="javascript:;" class="modal-close modal-window-close-button" @click="hidePresenceWarningModal()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </div>
      <div v-if="presenceInfoModalActive === 'warning'" class="modal-overlay" @click="hidePresenceWarningModal(false)"></div>
      <div v-else-if="presenceInfoModalActive === 'reload'" class="modal-overlay"></div>
    </div>
  </div>
</template>

<script>
import KundeKontraktObjektSidebarNotater from './KundeKontraktObjektSidebarNotater'
import KundeKontraktObjektSidebarHistorikk from './KundeKontraktObjektSidebarHistorikk'

import KundeKontraktObjektTabOversikt from './KundeKontraktObjektTabOversikt'
import KundeKontraktObjektTabSelger from './KundeKontraktObjektTabSelger'
import KundeKontraktObjektTabKjoper from './KundeKontraktObjektTabKjoper'
import KundeKontraktObjektTabBesiktelse from './KundeKontraktObjektTabBesiktelse'
import KundeKontraktObjektTabKonsultasjon from './KundeKontraktObjektTabKonsultasjon'
import KundeKontraktObjektTabBudhistorikk from './KundeKontraktObjektTabBudhistorikk'

import KundeKontraktObjektForm from './KundeKontraktObjektForm'
import KundeKontraktObjektSidebar from './KundeKontraktObjektSidebar'
import KundeService from '@/services/KundeService'
import ObjektService from '@/services/ObjektService'
import Presence from '@/plugins/presence'

import { mapGetters } from 'vuex'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjekt',
  components: {
    KundeKontraktObjektSidebar,
    KundeKontraktObjektSidebarNotater,
    KundeKontraktObjektSidebarHistorikk,
    KundeKontraktObjektForm
  },
  props: {
    loadObjektId: {
      type: [Number],
      required: true
    }
  },
  data () {
    return {
      kunde: {},
      kontrakt: {},
      objekt: {},
      loadingObjectData: true,
      reloadingObjectData: false,
      lastOppgjorLog: null,
      loading: true,
      edit: false,
      cmdSClicked: false,
      isReseting: false,
      isDeleting: false,
      resetConfirmActive: false,
      deleteConfirmActive: false,
      actionsPopoverActive: false,
      savePopoverActive: false,
      tabs: {
        'oversikt': {name: 'Oversikt', component: KundeKontraktObjektTabOversikt},
        'selger': {name: 'Oppgjør', component: KundeKontraktObjektTabSelger},
        'kjoper': {name: 'Kjøper', component: KundeKontraktObjektTabKjoper},
        'besiktelse': {name: 'Besiktigelse', component: KundeKontraktObjektTabBesiktelse},
        'konsultasjon': {name: 'Konsultasjon', component: KundeKontraktObjektTabKonsultasjon},
        'budhistorikk': {name: 'Budhistorikk', component: KundeKontraktObjektTabBudhistorikk}
      },
      selectedTab: 'oversikt',
      selectedTabComponent: KundeKontraktObjektTabOversikt,
      sidebarModal: '',
      objektImages: [],
      precence: null,
      presenceChannelName: null,
      presenceInfoModalActive: false
    }
  },
  watch: {
    objekt: function () {
      // Edit mode?
      const openEdit = Number(sessionStorage.getItem('openEdit') || 0)

      if (this.$route.hash === '#edit') {
        this.edit = true
      } else if (openEdit) {
        this.edit = true
        // Remove from session storage
        sessionStorage.removeItem('openEdit')
      } else {
        this.edit = false
      }

      // Always load objektnotater
      this.$store.dispatch('objektnotat/reinit', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr,
        Objektid: this.objekt.Objektid
      })

      // ...and load objekthistory
      this.$store.dispatch('objekthistory/reinit', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr,
        Objektid: this.objekt.Objektid
      })
    },
    isPresenceOwner: function (newVal, oldVal) {
      if (newVal === false) {
        this.showPresenceWarningModal()
      } else if (newVal && oldVal === false) {
        this.showPresenceReloadModal()
      }
    }
  },
  created: function () {
    this.baseUrl = process.env.VUE_APP_BQ22_FRONTEND_URL
    this.presence = new Presence()

    // bus.$off('after-save')
    bus.$off('close-objekt-sidebar')
    bus.$off('objekt-modal-update')
    bus.$off('objekt-modal-switch')
    bus.$off('objekt-modal-reload')

    var vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        // window.jQuery('.has-popover').removeClass('popover-active')
        vm.actionsPopoverActive = false
        vm.savePopoverActive = false
      }
    })

    // Init with false = not reload
    this.init(false)
  },
  mounted: function () {
    // bus.$on('after-save', (data) => this.onAfterSave(data))
    bus.$on('close-objekt-sidebar', () => this.toggleSidebar())
    bus.$on('kontrakt-objekter-transferred', (newKontrakt) => this.onObjekterTransferred(newKontrakt))
    bus.$on('close-objekt-edit', () => this.closeAfterSave())

    bus.$on('objekt-modal-update', (item) => this.onObjektUpdated(item))
    bus.$on('objekt-modal-switch', (item) => this.onObjektSwitched(item))

    bus.$on('objekt-modal-reload', () => this.onObjektReload())
  },
  beforeDestroy () {
    if (this.presenceChannelName) {
      this.presence.unsubscribe(this.presenceChannelName)
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    ...mapGetters('objektnotat', ['totalCount']),
    presenceErrors: function () {
      return this.$store.getters['presence/errors'](this.presenceChannelName)
    },
    presenceLoading: function () {
      return this.$store.getters['presence/loading'](this.presenceChannelName)
    },
    presenceMe: function () {
      return this.$store.getters['presence/me'](this.presenceChannelName)
    },
    presenceOwner: function () {
      return this.$store.getters['presence/owner'](this.presenceChannelName)
    },
    isPresenceOwner: function () {
      if (this.avantiEnv === 'local' || this.avantiEnv === 'staging') {
        return true
      }
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    },
    presenceMembers: function () {
      return this.$store.getters['presence/members'](this.presenceChannelName)
    },
    visiblePresenceMembers: function () {
      const items = this.presenceMembers.filter(item => item.id !== this.presenceMe.id)

      // More than 2 items in array, when removed myself?
      if (items && items.length > 2) {
        // Return the next 2 items, nd skip the rest
        return items.slice(0, 2)
      }

      return items || []
    },
    invisiblePresenceMembers: function () {
      const items = this.presenceMembers.filter(item => item.id !== this.presenceMe.id)

      // More than 2 items in array, when removed myself?
      if (items && items.length > 2) {
        // Return the rest after the two first ones, as the re used in the visible method above.
        return items.slice(2)
      }

      return []
    },
    isResetable: function () {
      // Must be the current editor of page
      if (!this.isPresenceOwner) {
        return false
      }

      // Cannot be an invoiced object
      if (this.objekt.Salgbilagsnr || this.objekt.Oppgjorbilagsnr) {
        return false
      } else if (this.objekt.Fakturert === 'F') {
        // Fallback
        return false
      }

      return true
    },
    isDeletable: function () {
      // Must be the current editor of page
      if (!this.isPresenceOwner) {
        return false
      }

      // Object can NOT be invoice or have a Tilslagnr, Mottaker, Salgspris
      if (this.objekt.Fakturert === 'F') {
        return false
      }
      if (this.objekt.Tilslagnr) {
        return false
      }
      if (this.objekt.Mottaker) {
        return false
      }

      if (this.objekt.Salgspris) {
        return false
      }

      if (this.objekt.auksjonsdato) {
        // Avdeling 0: Auksjon.Auksjon_dato
        // Avdeling 1 & 2: MAX(Nettobjekt.Slutt)
        return false
      }

      if (!this.hasAccess('admin')) {
        // If not admin, check so I am owner of the contract
        if (this.kontrakt.Mottaker !== this.getUser.Brukernavn) {
          return false
        }
      }

      return true
    },
    itemFullscreenLink: function () {
      return '/kunde/' + this.kunde.Kundenr + '?kontrakt=' + this.kontrakt.Kontraktnr + '&objekt=' + this.objekt.Objektid
    },
    notatCount: function () {
      const cnt = (this.totalCount || 0)

      if (this.objekt.Merknad) {
        return cnt + 1
      }

      return cnt
    }
  },
  methods: {
    init: function () {
      if (!this.loadObjektId) {
        this.$helpers.showErrorAlert('Feil', 'Objekt ikke funnet')
        this.closeModal()
        return
      }

      this.loadObjektById(this.loadObjektId, false, true)
    },
    loadObjektById: function (id, reloading = false, changedObject = false) {
      this.reloadingObjectData = reloading

      if (changedObject) {
        if (this.presenceChannelName) {
          this.presence.unsubscribe(this.presenceChannelName)
        }
      }

      ObjektService.view(id)
        .then(response => {
          // Setup everything
          this.objekt = response.data
          this.kontrakt = response.data.kontrakt
          this.kunde = response.data.kontrakt.kunde

          // Set name for the WS channel
          this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid

          // Set tab
          let tab = 'oversikt'
          const sot = sessionStorage.showObjektTab || 'oversikt'
          if (this.tabs.hasOwnProperty(sot)) {
            tab = sot
            sessionStorage.showObjektTab = null
          }
          this.tab(tab)

          // Edit mode?
          this.edit = this.$route.hash === '#edit'

          if (changedObject) {
            // Start listening to websocket
            this.presence.subscribe(this.presenceChannelName)
          } else {
            // Send event that objekt is updated
            bus.$emit('kunde-kontrakt-objekt-updated', response.data)
          }
        })
        .catch(error => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Objekt ikke funnet')
          this.closeModal()
        })
        .then(() => {
          this.reloadingObjectData = false
          this.loadingObjectData = false
        })
    },
    onObjektUpdated: function (item) {
      this.objekt = item
      this.kontrakt = item.kontrakt
      this.kunde = item.kontrakt.kunde
    },
    onObjektSwitched: function (item) {
      this.loadObjektById(item.Objektid, true, true)
    },
    onObjektReload: function () {
      console.log('In reload event')
      this.loadObjektById(this.objekt.Objektid, true, false)
    },
    showPresenceWarningModal: function () {
      this.presenceInfoModalActive = 'warning'
    },
    hidePresenceWarningModal: function () {
      this.presenceInfoModalActive = null
    },
    showPresenceReloadModal: function () {
      this.presenceInfoModalActive = 'reload'
    },
    hidePresenceReloadModal: function () {
      this.presenceInfoModalActive = null

      this.loadObjektById(this.loadObjektId, true, false)
    },
    theSaveShortkeyAction: function (status) {
      var vm = this

      if (!this.isPresenceOwner) {
        return
      }

      if (!this.cmdSClicked && !this.$store.getters.isFormProcessing && !this.$store.getters.isFormLoading) {
        this.cmdSClicked = true

        this.onSaveButtonclick(status)

        setTimeout(() => {
          vm.cmdSClicked = false
        }, 1000)
      }
    },
    onSaveButtonclick: function (status) {
      if (!this.isPresenceOwner) {
        console.log('Do not save - you are not owner')
      } else {
        bus.$emit('objekt-form-submit', { status: status })
      }
    },
    toggleActionsPopover: function () {
      this.actionsPopoverActive = !this.actionsPopoverActive
    },
    toggleSavePopover: function () {
      if (this.isPresenceOwner) {
        this.savePopoverActive = !this.savePopoverActive
      }
    },
    onObjekterTransferred: function (newKontrakt) {
      // Reload list of objekter
      this.$store.dispatch('kundekontraktobjekt/reload', {
        kontrakt: this.kontrakt
      })

      // Show alert with link to newly created kontrakt
      this.$helpers.showSuccessAlert(
        'Objekter flyttade till kontrakt',
        '<a href="' + '/kunde/' + this.kunde.Kundenr + '?kontrakt=' + newKontrakt.Kontraktnr + '">Gå til Kontrakt</a>',
        true,
        10000
      )

      this.closeModal()
    },
    action: function (action) {
      switch (action) {
        case 'print-etikett':
          this.openModal(
            'print-labels-modal',
            {
              objekt: this.objekt
            },
            'medium'
          )
          break
        case 'copy-objekt':
          this.$store.dispatch('SHOW_ALERT', {
            title: 'Objektet blir nå kopiert',
            subtitle: 'Vennligst vent...',
            isHtml: true,
            level: 'warning'
          })

          // Text if more than one: objektene
          ObjektService.duplicate(this.objekt.Objektid)
            .then(response => {
              // Hide warning alert
              this.$store.dispatch('HIDE_ALERT')

              // Show success alert
              this.$helpers.showSuccessAlert('Objektet har blitt kopiert')

              // Emit event so we can update list
              bus.$emit('kunde-kontrakt-objekt-created', null)
            })
            .catch(error => {
              console.log('Error', error)
              // Hide warning alert
              this.$store.dispatch('HIDE_ALERT')

              // Show error alert
              this.$helpers.showErrorAlert('Kunne ikke kopiere objektet', 'Vennligst prøv igjen', 2500)
            })
          break
        case 'move-objekt':
          if (this.edit && this.isFormDirty('objektform')) {
            this.$helpers.showErrorAlert('', 'Du har gjort endringer på objektet,<br>vennligst lagre før du går videre.', true)
          } else if (!this.isPresenceOwner) {
            // Not owner - can not move object...
            return false
          } else {
            let selectedObjekter = []
            selectedObjekter.push(this.objekt.Objektid)

            this.openModal(
              'kunde-kontrakt-transfer-modal',
              {
                kunde: this.kunde,
                kontrakt: this.kontrakt,
                objektlist: selectedObjekter
              }
            )
          }
          break
      }
    },
    tab: function (tab) {
      if (this.tabs.hasOwnProperty(tab)) {
        // Save to localstorage - to remember
        // localStorage.kko_tab = tab

        this.selectedTab = tab
        this.selectedTabComponent = this.tabs[tab].component
      }
    },
    closeAfterSave: function () {
      this.edit = false
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: this.$route.query,
        hash: ''
      })
    },
    toggleEdit: function () {
      if (this.edit && this.isFormDirty('objektform')) {
        let vm = this
        // this.$helpers.showErrorAlert('', 'Du har gjort endringer på objektet,<br>vennligst lagre før du går videre.', true)
        this.openConfirm(
          'Advarsel',
          'Du har gjort endringer på objektet.',
          'Lagre og lukk',
          'Lukk uten å lagre',
          function () {
            // Trigger save - and send closeAfterSave, so we go to show view after save is done.
            vm.closeModal()
            bus.$emit('objekt-form-submit', { status: vm.objekt.Tekst_ok === 'T', closeAfterSave: true })
          },
          function () {
            vm.closeModal()
            vm.setFormDirty('objektform', false)
            vm.edit = false

            vm.$router.push({
              name: vm.$route.name,
              params: vm.$route.params,
              query: vm.$route.query,
              hash: ''
            })
          }
        )
      } else {
        this.edit = !this.edit

        // Skip #edit hashtag ???
        // this.$router.push({
        //   name: this.$route.name,
        //   params: this.$route.params,
        //   query: this.$route.query,
        //   hash: this.edit ? '#edit' : ''
        // })
      }
    },
    toggleSidebar: function (sidebar) {
      if (this.sidebarModal === sidebar) {
        this.sidebarModal = null
      } else {
        this.sidebarModal = sidebar === undefined ? null : sidebar
      }
    },
    goToKontrakt: function () {
      if (this.edit && this.isFormDirty('objektform')) {
        this.$helpers.showErrorAlert('', 'Du har gjort endringer på objektet,<br>vennligst lagre før du går videre.', true)
      } else {
        this.closeModal()
      }
    },
    resetConfirm: function () {
      if (this.isResetable) {
        this.resetConfirmActive = true
      }
    },
    onResetConfirmTrue: function () {
      this.setFormProcessing(true)
      this.isReseting = true

      // Just add the data we want to reset/update
      const resetData = {
        Tilslagnr: null,
        Mottaker: null,
        Salgspris: null
      }

      KundeService.saveKundeKontraktObjekt(this.kunde.Kundenr, this.kontrakt.Kontraktnr, this.objekt.Objektid, resetData)
        .then((response) => {
          // Show success alert
          this.$helpers.showSuccessAlert('Objekt har blitt oppdatert')

          // Emit event so we can update list
          bus.$emit('objekt-modal-update', response.data)
          bus.$emit('kunde-kontrakt-objekt-updated', response.data)
        })
        .catch((error) => {
          console.log(error)
          this.$helpers.showErrorAlert('Kunne ikke nullstille objekt', 'Vennligst prøv igjen', 2500)
        })
        .then(() => {
          this.isReseting = true
          this.resetConfirmActive = false
          this.setFormProcessing(true)
        })
    },
    onResetConfirmFalse: function () {
      this.resetConfirmActive = false
    },
    deleteConfirm: function () {
      if (this.isDeletable) {
        this.deleteConfirmActive = true
      }
    },
    onDeleteConfirmTrue: function () {
      this.setFormProcessing(true)
      this.isDeleting = true

      KundeService.deleteKundeKontraktObjekt(this.kunde.Kundenr, this.kontrakt.Kontraktnr, this.objekt.Objektid)
        .then((response) => {
          this.deleteConfirmActive = false

          // Go to kontrakt
          bus.$emit('kunde-kontrakt-objekt-deleted')
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke slette objektet')
        })
        .then(() => {
          this.isDeleting = false
          this.setFormProcessing(false)
        })
    },
    onDeleteConfirmFalse: function () {
      this.deleteConfirmActive = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektModal.vue